import { useNavigate } from "react-router-dom";
import MobileLayout from "@/components/MobileLayout";
import Footer from "@/components/layout/Footer";
import { Button } from "@/components/ui/button";
import { useLanguage } from "@/i18n/LanguageProvider";

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <MobileLayout>
      <div className="flex flex-1 flex-col items-center justify-center">
        <h1 className="font-display text-4xl font-bold text-gradient mb-2">404</h1>
        <p className="text-muted-foreground text-sm mb-6">{t("notFound.message")}</p>
        <Button variant="hero" soundOnPress={false} onClick={() => navigate("/")}>
          {t("notFound.return")}
        </Button>
      </div>
      <Footer variant="minimal" />
    </MobileLayout>
  );
};

export default NotFound;
